import { useContext, useMemo } from "react";
import { AvisForm, IAvisFormProps } from "../../../../shared/components";
import { ICreationBaseInfo, IUrlParamsAuthors } from "../../../../../models";
import { AuthorsUtils, IAxiosError } from "../../../../../utils";
import { AvisConstants } from "../../../../../data/avisConstants";
import { AvisContext } from "../../../../shared/context";

export interface ICreationBasePageProps extends IAvisFormProps {
  urlParams: IUrlParamsAuthors;
  error: IAxiosError | undefined;
  setError: React.Dispatch<React.SetStateAction<IAxiosError | undefined>>;
  data?: ICreationBaseInfo | undefined;
}
export function CreationBasePage(props: Readonly<ICreationBasePageProps>) {
  const { data, pageTitle, children, loading, error, ...restProps } = props;

  const { ctxRightsHolder, res } = useContext(AvisContext);

  const pageTitleValue = useMemo(() => {
    if (loading) return;

    if (pageTitle) return pageTitle;

    return `${data?.creationName}`;
  }, [data, loading, pageTitle]);

  return (
    <AvisForm
      {...restProps}
      pageTitle={pageTitleValue}
      className="creation-form-view-wrapper"
      error={error}
      backLink={{
        title: res("authors_Creation_label_BackToList"),
        url: AuthorsUtils.getRightsHolderPagePath(
          ctxRightsHolder,
          `${AvisConstants.url_part_creations}${AvisConstants.url_hash_filter}`,
        ),
      }}
    >
      {children}
    </AvisForm>
  );
}
